/**
 * Rótulos e formatos compartilhados pela Visão geral e pela aba Indicadores (PROJETOS-LIMPO 2).
 * Só texto e formatação — nenhuma conta mora aqui (o motor da obra é o servidor).
 */
import { formatCurrency } from '@/lib/format';
import { CUSTO_CATEGORIA_LABEL, type ProjetoIndicadores } from '@/lib/projetos-store';

/** O rótulo canônico das categorias de custo (um só, o do store). */
export const CATEGORIA_LABEL: Record<string, string> = CUSTO_CATEGORIA_LABEL;

export function cent(c: number | null | undefined): string {
  return c === null || c === undefined ? '—' : formatCurrency(c / 100);
}

export function pct(p: number | null | undefined): string {
  return p === null || p === undefined ? '—' : `${p.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
}

export function fonteDoVendido(fonte: ProjetoIndicadores['vendido']['fonte']): string {
  switch (fonte) {
    case 'orcamento-aprovado':
      return 'do orçamento aprovado no Ganho';
    case 'itens':
      return 'soma dos itens vendidos (obra sem venda congelada)';
    default:
      return 'esta obra não tem venda registrada';
  }
}
